import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '../../../../components/ui/dialog';

interface TermsModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function TermsModal({ open, onOpenChange }: TermsModalProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-xl">
				<DialogHeader>
					<DialogTitle>Terms and Conditions</DialogTitle>
				</DialogHeader>
				<DialogBody className="scroll-thin max-h-[70vh] overflow-y-auto">
					<div className="flex flex-col gap-4 text-sm leading-relaxed text-text-2">
						<p>
							(a) Quotations are based on current costs of materials and services.
							Unless otherwise agreed in writing, they are subject to amendment to
							meet any rise in such costs between the date of quotation and the date
							of execution.
						</p>
						<p>
							(b) When the buyer opts out of the sample process the buyer is not
							entitled to remedies.
						</p>
						<p>
							(c) When quotations are based on specifications, roughs, layouts,
							samples, dummies or printed, typewritten or other good copy provided by
							the client, any extra work or cost caused by any variation by the
							customer of their original instructions or specifications shall be
							additionally chargeable.
						</p>
						<p>
							(d) Upon acceptance by the customer, 05Aps written quotation shall be
							deemed to have interpreted the customer&apos;s instructions correctly.
						</p>
						<p>
							(e) Shipping cost are based on estimated conditions, packing size and
							weight, and are subject to amendment to meet potential changes in such
							costs between the date of quotation and the date of execution.
							Additional charges may apply for custom clearance, custom exam, and
							extra fees during transportation.
						</p>
						<p>
							(f) Freight charges only include delivery charges from the factory to
							the destination. As such, customers shall be responsible for any
							surcharges such as (but not limited to) rerouting charges, reschedule
							charges, labor charges for offloading charges, indoor delivery charges,
							containers drop off and pick up charges, and chassis rental charges.
						</p>
						<p>
							(g) Digital print samples may have color variance with final production
							orders due to different print methods and color reproduction processes.
						</p>
						<p>
							(h) Any visible damage, reduction or loss shall be reported immediately
							upon the receipt of the goods, and be noted on the transport document or
							in another document. If shipping damage is discovered after receipt of
							goods, it must be reported within 3 days.
						</p>
						<p>
							(i) The Consignee shall check the dimensions and artworks upon receiving
							the goods. Any issues must be reported within 3 days after reception. If
							damage caused by packaging is discovered after receipt of goods, it must
							be reported within 3 days.
						</p>
					</div>
				</DialogBody>
			</DialogContent>
		</Dialog>
	);
}
